import React from "react";
import "../Common/css/styles.css";
import { useLocation } from "react-router-dom";
import ReactPlayer from "react-player";

export default function Recording() {
    const location = useLocation();
    const { state } = location;
    const { link, title } = state || {};

    const isYouTube = ReactPlayer.canPlay(link) && link?.includes("youtube");

    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h2 style={{ color: '#fff' }}>{title || "Recording"}</h2>
            <div className="space"></div>
            
            {link ? (
                <div style={{ position: 'relative', width: '100%', maxWidth: '900px', margin: '0 auto' }}>
                    <ReactPlayer
                        url={link}
                        controls
                        width="100%"
                        height="500px"
                    />

                    {/* Overlay to block YouTube Share button (top-right corner) */}
                    {isYouTube && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: '80px',
                                height: '60px',
                                zIndex: 2,
                                backgroundColor: 'transparent',
                                cursor: 'not-allowed',
                            }}
                            title="Restricted"
                        />
                    )}
                </div>
            ) : (
                <p style={{ color: '#aaa' }}>Invalid or missing recording link.</p>
            )}
        </div>
    );
}
